export default __webpack_public_path__ + "static/media/call.88771016.svg";